/**
 * `JSON.stringify` that never throws. When the value cannot be encoded
 * (a cycle, a BigInt) or encodes to nothing (`undefined`, a function, a
 * symbol), the caller's `fallback` supplies the text instead.
 */
export function safeStringify(value: unknown, fallback: (value: unknown) => string): string {
    try {
        return JSON.stringify(value) ?? fallback(value);
    } catch {
        return fallback(value);
    }
}
